/**
 * หุบเขาจันทร์มัว (หุบจันทร์มัว): seductive and yin. The erhu sighs in slides and vibrato, the
 * zheng answers with pressed and wavering notes (按 and 揉), half-heard bells.
 */
import { arp, drone, octave } from '../compose';
import { registerTrack } from '../registry';

const A_ERHU = `@mf 6,. 1_ 3/- | 2_ 3_ 2_ 1_ 6,~- | 3. 5_ 6~ 5_ 3_ | 2\\--- ; |
  6. 1'_ 6 5_ 3_ | 5/- 3_ 2_ 3 | 2_ 1_ 6,_ 5,_ 6, 1 | 6,~---`;
const A_ZHENG = `@mp 0--- | 0--- | 0--- | 0- 7^ 6~ | 0--- | 0--- | 0--- | 0- 4^_ 3_ 2\\`;
const ROOTS_A = `6,, 2, 3, 6,, 6,, 5,, 3,, 6,,`;
const SWAY = [0, 2, 3, 5, null, 3, 2, null];

const B_ZHENG = `@mf 3'g. 2'_ 1'~ 6 | 7^- 6_ 5_ 6 | 1'_ 2'_ 3' 4'^_ 3'_ 2' | 3'~--- |
  6. 1'_ 7^ 6_ 5_ | 3_ 5_ 6~ 5_ 3_ 2 | 1_ 2_ 3_ 2_ 1 6, | 6,%---`;
const B_ERHU = `@p 0--- | 3'--- ; | 0--- | 6--- ; | 0--- | 1'- 7- | 6--- | 0---`;
const ROOTS_B = `6,, 3,, 6,, 3,, 6,, 1, 5,, 6,,`;

const BELLS = `h--- | 0--- | 0--- | 0--- | b--- | 0--- | 0--- | 0---`;

registerTrack({
  id: 'dim-moon',
  order: 9,
  title: 'เงาจันทร์ในหุบจันทร์มัว',
  mood: 'ยั่วยวน ลึกลับ หยิน',
  use: 'หุบเขาจันทร์มัว (หุบจันทร์มัว) ทั้งกลางวันและกลางคืน',
  key: 'E',
  mode: 'yu',
  bpm: 68,
  meter: 4,
  seed: 909,
  humanize: 0.7,
  parts: {
    erhu: { inst: 'erhu', pan: -0.15, reverb: 0.45 },
    zheng: { inst: 'zheng', pan: 0.2, reverb: 0.4 },
    harp: { inst: 'zheng', gain: 0.4, pan: 0.3, reverb: 0.4 },
    pad: { inst: 'pad', gain: 0.75, reverb: 0.5 },
    bells: { inst: 'perc', gain: 0.16, pan: -0.3, reverb: 0.7 },
  },
  sections: {
    A: {
      bars: 8,
      parts: { erhu: A_ERHU, zheng: A_ZHENG, harp: arp(ROOTS_A, SWAY), pad: drone(ROOTS_A, 4), bells: BELLS },
    },
    B: {
      bars: 8,
      parts: {
        zheng: B_ZHENG,
        erhu: B_ERHU,
        harp: arp(ROOTS_B, [0, null, 3, null, 2, null, 3, null]),
        pad: drone(ROOTS_B, 4),
        bells: BELLS,
      },
    },
    A2: {
      bars: 8,
      parts: {
        erhu: octave(A_ERHU, 1),
        zheng: A_ZHENG,
        harp: arp(ROOTS_A, SWAY),
        pad: drone(ROOTS_A, 4),
        bells: BELLS,
      },
    },
  },
  form: ['A', 'B', 'A2', 'B'],
  loop: true,
});
